function ShapesIcon(props)
{
    return(
       <svg className={props.class} viewBox="0 0 100 112" style={{"margin":'.2rem .1rem .1rem .2rem'}}>
  <g transform="translate(-16.01568,-7.1297164)">
    <path style={{"fill":"none","stroke":"#ffffff","strokeWidth":"10","strokeMiterlimit":"5.8","strokeDasharray":"none","paintOrder":"stroke fill markers"}} d="M 41.355312,104.40637 H 105.23505 L 72.947544,48.482758 Z"/>
    <path style={{"fill":"none","stroke":"#ffffff","strokeWidth":"10","strokeMiterlimit":"5.8","strokeDasharray":"none","paintOrder":"stroke fill markers"}} d="m 42.679659,82.143728 -8.62363,-5.408039 -6.577344,-6.431182 -3.800244,-7.454324 -2.192448,-7.454324 -0.730816,-8.477466 1.315469,-7.161998 3.361754,-8.331303 5.261876,-7.746651 7.30816,-6.431181 9.06212,-4.09257 9.354445,-1.315469 6.869672,0.146163 8.18514,2.338611 5.408039,3.215591 5.992691,4.53106 5.992692,7.161997 2.484775,5.700366 1.900122,4.969549 0.876979,5.992692 -0.146163,6.723508 -0.584653,4.238733"/>
  </g>
</svg>
    )
}

export default ShapesIcon